'use strict';

var React = require('react');

var SvgPopularMajor = function SvgPopularMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.984 18a.999.999 0 0 1-.94-.658l-3.077-8.454-2.05 5.465a1.001 1.001 0 0 1-1.794.163l-2.188-3.646-1.124 1.685a1.002 1.002 0 0 1-1.665-1.11l2.001-3a.966.966 0 0 1 .856-.444.998.998 0 0 1 .834.485l1.936 3.223 2.271-6.059a1 1 0 0 1 .938-.65h.005a1.001 1.001 0 0 1 .935.658l2.948 8.1 3.154-11.033c.12-.42.502-.714.94-.724.43-.026.834.268.97.683l2.002 6a1 1 0 1 1-1.897.631l-.98-2.932-3.112 10.888a1 1 0 0 1-.928.726h-.035"
  }));
};

exports.SvgPopularMajor = SvgPopularMajor;
